<template>
  <v-card tile>
    <v-toolbar flat color="app-blue" dark class="card-header">
      <span class="text-h5 font-weight-light" v-if="task.id">
        {{ $t('tasks.editTask') }}
      </span>
      <span class="text-h5 font-weight-light" v-else>
        {{ $t('tasks.createTask') }}
      </span>
      <v-spacer></v-spacer>
      <v-btn text icon @click="$emit('close')" class="mr-0">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </v-toolbar>
    <v-container grid-list-md class="pa-6 pb-0">
      <v-form ref="manageMissionTaskForm">
        <v-text-field
          solo
          v-model="task.title"
          :rules="[rules.required]"
          :label="$t('common.title')"
          :disabled="task.completed"
        ></v-text-field>
        <v-textarea
          solo
          v-model="task.notes"
          :label="$t('common.notes')"
          :disabled="task.completed"
        ></v-textarea>
        <v-text-field
          solo
          :min="goldEnum.minGold"
          :max="goldEnum.maxGold"
          :rules="[rules.required, rules.isInteger, rules.minMaxGold]"
          v-model="task.gold"
          :label="$t('common.gold')"
          :disabled="task.completed"
          :hint="
            $t('common.minMaxValue', {
              min: goldEnum.minGold,
              max: goldEnum.maxGold
            })
          "
        ></v-text-field>
        <v-select
          v-model="task.tags"
          :items="mappedTags"
          :rules="[rules.maxArrayLength]"
          chips
          :label="$t('tags.tags')"
          item-value="id"
          item-text="name"
          multiple
          solo
          class="tags-select"
          :disabled="task.completed"
        >
          <template #selection="{ item }">
            <v-chip color="app-blue">{{ item.name }}</v-chip>
          </template>
        </v-select>
        <h3>{{ $t('tasks.type') }}</h3>
        <v-radio-group v-model="task.type" row :disabled="task.completed">
          <v-radio
            :label="$t('tasks.todo')"
            :value="taskTypes.todo"
            color="app-blue"
            class="mb-2"
          ></v-radio>
          <v-radio
            :label="$t('tasks.daily')"
            :value="taskTypes.daily"
            color="app-blue"
            class="mb-2"
          ></v-radio>
          <v-radio
            :label="$t('tasks.weekly')"
            :value="taskTypes.weekly"
            color="app-blue"
            class="mb-2"
          ></v-radio>
        </v-radio-group>
      </v-form>
    </v-container>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="app-blue" text @click="save()" :disabled="task.completed">
        {{ $t('common.save') }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { mapGetters } from 'vuex';
import validators from '@/common/validators';
import goldEnum from '../../enums/gold';
import taskTypes from '../../enums/task.types';

const MIN_TAGS = 0;
const MAX_TAGS = 3;

export default {
  name: 'manage-mission-task-modal',
  props: {
    selectedTask: Object,
    selectedTypeFilter: {
      type: String,
      default: taskTypes.todo
    }
  },
  computed: {
    ...mapGetters(['tags']),
    mappedTags() {
      return this.tags.map(tag => ({
        id: tag.id,
        name: this.$i18n.t(`tags.${tag.name}`)
      }));
    }
  },
  data() {
    return {
      taskTypes,
      task: {
        title: '',
        notes: '',
        gold: '',
        type: this.selectedTypeFilter,
        tags: []
      },
      rules: {
        required: validators.required(this.$i18n.t('common.requiredField')),
        isInteger: validators.isInteger(this.$i18n.t('common.goldInteger')),
        minMaxGold: validators.minMaxValue(
          goldEnum.minGold,
          goldEnum.maxGold,
          this.$i18n.t('common.minMaxValue', {
            min: goldEnum.minGold,
            max: goldEnum.maxGold
          })
        ),
        maxArrayLength: validators.minMaxArrayLength(
          MIN_TAGS,
          MAX_TAGS,
          this.$i18n.t('tasks.maxTagsLength', { number: MAX_TAGS })
        )
      },
      goldEnum
    };
  },
  created() {
    if (this.selectedTask) {
      this.populateTask();
    }
  },
  methods: {
    populateTask() {
      if (this.selectedTask) {
        this.task = {
          ...this.selectedTask,
          tags: this.selectedTask.tags.map(tag => tag.id)
        };
      }
    },
    save() {
      if (!this.$refs.manageMissionTaskForm.validate()) {
        return;
      }

      this.$emit('close', this.task);
    }
  }
};
</script>
